export const set_editMode = "SET_EDIT_MODE";
export const set_viewMode = "SET_VIEW_MODE";

const updateEditMode = (state, action) => {
    if (state === undefined) return true;

    switch (action.type) {
        case set_editMode:
            return true;
        case set_viewMode:
            return false;
        default:
            return state.app.settings.editMode;
    }
};

export default updateEditMode;
